import React, {useEffect} from 'react';
import {useStore} from '@/app/providers/StoreProvider';
import {observer} from 'mobx-react-lite';
import {Loading} from '@/shared/ui/Loading';
import {useLocation} from 'react-router-dom';
import {TeamMemberList} from '@/entities/team/ui/TeamMemberList';
import {TeamInfo} from '@/entities/team/ui/TeamInfo';


export const TeamPage = observer(() => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id");

    const {teamStore, userStore} = useStore();
    const {user} = userStore;
    const {team, myTeam, link, loadingTeams} = teamStore;

    useEffect(() => {
        if (id) {
            teamStore.getTeam(id);
        }
        teamStore.getInviteLink();
        if (!myTeam) {
            teamStore.getMyTeam();
        }
    }, [id]);

    if (!team || loadingTeams) return <Loading/>

    if (id) {
        return (
            <div className='team-page'>
                <div className="container">
                    <div className='team'>
                        <TeamInfo user={user} team={team} link={link}/>
                        <TeamMemberList team={team} minHeight={!myTeam}/>
                        {!myTeam &&
                            <div className='team_button blue invite' onClick={() => teamStore.joinTeam(team.inviteCode)}>Вступить
                                в команду</div>}
                    </div>
                </div>
            </div>
        )
    }
});
